import * as React from 'react'
import type { FocusNavigation } from '../deps/mode/focusNavigation/focusNavigation.types'

/**
 * Hook to toggle focus navigation mode with the 'F' key.
 * Focus navigation mode is persistent - it stays on/off until toggled.
 */
export function useFocusNavigationToggle(focusNavigation: FocusNavigation) {
  // Handle 'F' key to toggle focus navigation (works both when active and inactive)
  React.useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Don't toggle if modifier keys are pressed
      if (e.ctrlKey || e.metaKey || e.altKey || e.shiftKey) {
        return
      }

      // Don't toggle when typing in input fields
      const target = e.target as HTMLElement
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
        return
      }

      if (e.key === 'f' || e.key === 'F') {
        e.preventDefault()
        e.stopPropagation()
        if (focusNavigation.isActive.value) {
          focusNavigation.disable()
        } else {
          focusNavigation.enable()
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [focusNavigation])
}
